var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#BC945C;}\r\n\t.st1{fill:#860038;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M356.2,121.3V98.4l-5.6-5.7c-72-68.5-226.2,21.4-278.6,64.8l-25.9,40.1l32.2-8c-49.4,62-31.8,102.7-29.7,106.9 c5.2,14.6,17.1,26.3,36.3,34c14.6,5.8,31.2,6.6,45.4,5.9c61.4-2.9,134-41.2,180.9-81.9l1.1-0.9l9.3-47.1l-18.2,10.1 c-63.3,27.8-114.2,43.2-114.2,43.2c-33.3,10.4-48.6,12.1-59.5,9.5l-1.3-0.4c-3-1.2-3.5-3.9-3.5-4.6c-0.5-20.8,35.4-65.6,53.4-85 c16.8-18.1,43.3-37.9,65.7-47.3c15-6.3,24.7-8.8,29.2-8.4c-1.2,3.9-3.3,8.7-6.2,14.5c0,0-24,47.3-25,49.2L356.2,121.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M213.9,118c-20.6,10.9-44.3,32.8-51.7,40.7C101.8,223,59.5,309,191.7,267.8c0,0,51.4-15.6,115.2-43.6 C126.3,376.8-44.2,313,123.6,152.5c-15.3,3.5-30.7,6.8-45.8,11c53.7-44.5,201.1-127.4,266.9-64.8l-70.3,43.1 C304.6,82.7,250.2,96.6,213.9,118"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCle);
export default __webpack_public_path__ + "static/media/CLE.7f0c1a9ea74b747e8a6f89f1c5bc9230.svg";
export { ForwardRef as ReactComponent };